export default __webpack_public_path__ + "static/AlternateTopicMonitoring-bg-03096f069572ca80151a12db3df3cd53.png";